import { useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import { HiOutlineExclamationTriangle } from "react-icons/hi2";

import Button from "@/components/atoms/Button";
import FeaturedIcon from "@/components/atoms/FeaturedIcon";
import BasicModalContent from "@/components/atoms/modal-panels/BasicModalContent";

export type FileLimitExceededModalProps = {
  onClose: (value: boolean) => void;
  preventClose?: boolean;
  onFileUpload: (file: File) => void;
};

const FileLimitExceededModal = ({ onClose, preventClose = false, onFileUpload }: FileLimitExceededModalProps) => {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileUpload(file);
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <BasicModalContent
      featuredIcon={<FeaturedIcon icon={HiOutlineExclamationTriangle} size={"lg"} color={"warning"} />}
      heading={t("enrich.file.tooLarge.heading")}
      preventClose={preventClose}
      body={
        <Trans
          i18nKey="enrich.file.tooLarge.description"
          values={{ size: "10MB" }}
          components={{ strong: <strong /> }}
        />
      }
      onClose={onClose}
    >
      <input type="file" accept=".csv" className={"hidden"} ref={fileInputRef} onChange={handleFileChange} />
      <div className="mt-4 grid grid-cols-2 gap-3">
        <Button type={"button"} label={t("cancel")} onClick={() => onClose(false)} color="natural" variants="outline" />
        <Button
          type={"button"}
          label={t("enrich.file.tooLarge.button")}
          onClick={() => handleButtonClick()}
          color="brand"
          variants="primary"
        />
      </div>
    </BasicModalContent>
  );
};

export default FileLimitExceededModal;
